import { EligibilityCheckResponse, EligibilityCheckResult, InsuranceEligibility, PlanStatusCode, ServiceTypeCode } from './types';

/**
 * https://expressable.slack.com/archives/C086VL2P4M6/p1736455905499809
 * insuranceEligibility is active
 * in plan network indicator is Y for the speech therapy benefit
 * The benefitsInformation.code is any (as long as benefitAmount is 0 (exempt from patient responsibility))
 */
export const isLeadEligible = (eligibilityInformation: EligibilityCheckResponse): EligibilityCheckResult => {
  // 1. Check if the insurance eligibility is active
  if (eligibilityInformation.insuranceEligibility !== InsuranceEligibility.Active) {
    return EligibilityCheckResult.INACTIVE;
  }
  // 2. Check for service type codes in planStatus for speechTherapy and generalHealth
  const speechTherapy = eligibilityInformation.eligibilityDetails?.planStatus?.speechTherapy?.find(status => status?.serviceTypeCodes?.includes(ServiceTypeCode.SPEECH_THERAPY));
  const generalHealth = eligibilityInformation.eligibilityDetails?.planStatus?.generalHealth?.find(status => status?.serviceTypeCodes?.includes(ServiceTypeCode.GENERAL_HEALTH));

  // 3. If either service exists but is not active, return INACTIVE
  // https://www.stedi.com/docs/healthcare/benefit-response#active-and-inactive-coverage
  if ((speechTherapy && speechTherapy.statusCode === PlanStatusCode.INACTIVE) || 
      (generalHealth && generalHealth.statusCode === PlanStatusCode.INACTIVE)) {
    return EligibilityCheckResult.INACTIVE;
  }

  // 4. Determine eligibility based on priority: speechTherapy > generalHealth
  if (speechTherapy?.statusCode === PlanStatusCode.ACTIVE ||
      generalHealth?.statusCode === PlanStatusCode.ACTIVE) {
    return EligibilityCheckResult.IN_NETWORK;
  }

  return EligibilityCheckResult.ERROR;
};
